export enum REWARD_KEY {
  ID_01 = '490205',
  ID_02 = '198857',
  ID_03 = '340694',
  ID_04 = '742129',
  ID_05 = '324876',
  ID_06 = '350418',
  ID_07 = '519118',
  ID_08 = '601944',
  ID_09 = '551688',
  ID_10 = '356462',
  ID_11 = '791354',
  ID_12 = '729315',
  ID_13 = '286180',
  ID_14 = '158311',
  ID_15 = '815754',
  ID_16 = '636654',
  ID_17 = '486980',
  ID_18 = '807140',
  ID_19 = '977900',
  ID_20 = '383585',
  ID_21 = '454924',
  ID_22 = '870514',
  ID_23 = '831546',
  ID_24 = '177830',
  ID_25 = '164581',
  ID_26 = '710465',
  ID_27 = '451364',
  ID_28 = '511238',
  ID_29 = '341925',
}

export interface IDishDetail {
  title: string
}

export interface IRewardData {
  _id: REWARD_KEY
  order: number
  title: string
  dishes: IDishDetail[]
}

export const _rewards: Record<REWARD_KEY, IRewardData> = {
  [REWARD_KEY.ID_01]: {
    _id: REWARD_KEY.ID_01,
    order: 1,
    title: 'Lobster City',
    dishes: [
      {
        title: 'มาม่าผัดขี้เมาทะเล',
      },
    ],
  },
  [REWARD_KEY.ID_02]: {
    _id: REWARD_KEY.ID_02,
    order: 2,
    title: 'เป็ดย่างบรรทัดทอง',
    dishes: [
      {
        title: 'ตูดเป็ดย่าง',
      },
      {
        title: 'ส้มตำไทย',
      },
      {
        title: 'ข้าวเหนียว',
      },
    ],
  },
  [REWARD_KEY.ID_03]: {
    _id: REWARD_KEY.ID_03,
    order: 3,
    title: 'มะม่วงน้ำปลาหวาน วังใหม่',
    dishes: [
      {
        title: 'มะม่วงน้ำปลาหวาน',
      },
    ],
  },
  [REWARD_KEY.ID_04]: {
    _id: REWARD_KEY.ID_04,
    order: 4,
    title: 'รัตติยาแจ่วฮ้อน',
    dishes: [
      {
        title: 'ตำเส้นเล็กหมูยอ',
      },
    ],
  },
  [REWARD_KEY.ID_05]: {
    _id: REWARD_KEY.ID_05,
    order: 5,
    title: 'Nam Dao Huu น้ำเต้าหู้',
    dishes: [
      {
        title: 'บัวลอยรวมน้ำขิงร้อน',
      },
      {
        title: 'น้ำเต้าหู้ร้อนทรงเครื่อง',
      },
    ],
  },
  [REWARD_KEY.ID_06]: {
    _id: REWARD_KEY.ID_06,
    order: 6,
    title: 'Boocha',
    dishes: [
      {
        title: 'มะม่วงเฟรบเป้โบบา',
      },
    ],
  },
  [REWARD_KEY.ID_07]: {
    _id: REWARD_KEY.ID_07,
    order: 7,
    title: 'รสข้นน้ำยาปูเชียงใหม่',
    dishes: [
      {
        title: 'น้ำยาปูธรรมดา ไซส์ s',
      },
    ],
  },
  [REWARD_KEY.ID_08]: {
    _id: REWARD_KEY.ID_08,
    order: 8,
    title: 'สว่างบะหมี่ก้ามปู บรรทัดทอง',
    dishes: [
      {
        title: 'บะหมี่ หมูแดง หมูกรอบ เนื้อปู',
      },
    ],
  },
  [REWARD_KEY.ID_09]: {
    _id: REWARD_KEY.ID_09,
    order: 9,
    title: 'ขาหมูตรอกซุง บรรทัดทอง',
    dishes: [
      {
        title: 'ข้าวขาหมูพิเศษ',
      },
    ],
  },
  [REWARD_KEY.ID_10]: {
    _id: REWARD_KEY.ID_10,
    order: 10,
    title: 'Newtro Cafe',
    dishes: [
      {
        title: 'Newtro Toast',
      },
    ],
  },
  [REWARD_KEY.ID_11]: {
    _id: REWARD_KEY.ID_11,
    order: 11,
    title: 'ข้าวต้มเทเวศร์',
    dishes: [
      {
        title: 'ข้าวต้มแห้งหมูรวมมิตร',
      },
    ],
  },
  [REWARD_KEY.ID_12]: {
    _id: REWARD_KEY.ID_12,
    order: 12,
    title: 'ชาญ บะหมี่ไก่ตุ๋น, เชียงใหม่',
    dishes: [
      {
        title: 'ไก่ตุ๋นรวม',
      },
    ],
  },
  [REWARD_KEY.ID_13]: {
    _id: REWARD_KEY.ID_13,
    order: 13,
    title: 'พาข้าว',
    dishes: [
      {
        title: 'ไส้กรอกอีสาน 1 ชุด',
      },
    ],
  },
  [REWARD_KEY.ID_14]: {
    _id: REWARD_KEY.ID_14,
    order: 14,
    title: 'โจ๊กสามย่าน',
    dishes: [
      {
        title: 'เซตโจ๊กแห้งไข่เค็ม เก๊กฮวย ปาท่องโก๋',
      },
    ],
  },
  [REWARD_KEY.ID_15]: {
    _id: REWARD_KEY.ID_15,
    order: 15,
    title: 'Haab ขนมไข่สงขลา',
    dishes: [
      {
        title: 'ขนมไข่ไซส์ L',
      },
    ],
  },
  [REWARD_KEY.ID_16]: {
    _id: REWARD_KEY.ID_16,
    order: 16,
    title: 'VELA Bar&bistro',
    dishes: [
      {
        title: 'ยำแมงกะพรุน',
      },
    ],
  },
  [REWARD_KEY.ID_17]: {
    _id: REWARD_KEY.ID_17,
    order: 17,
    title: 'Andy & Fine',
    dishes: [
      {
        title: 'ถ่ายรูป photobooth',
      },
    ],
  },
  [REWARD_KEY.ID_18]: {
    _id: REWARD_KEY.ID_18,
    order: 18,
    title: 'กุ้งถัง',
    dishes: [
      {
        title: 'ชุดหอยตลับ',
      },
    ],
  },
  [REWARD_KEY.ID_19]: {
    _id: REWARD_KEY.ID_19,
    order: 19,
    title: 'ร้านตั้งใจจุ่ม',
    dishes: [
      {
        title: 'ชุดเปิดหม้อกับน้องอุ่นใจ',
      },
    ],
  },
  [REWARD_KEY.ID_20]: {
    _id: REWARD_KEY.ID_20,
    order: 20,
    title: 'Junepang จูนปัง',
    dishes: [
      {
        title: 'คาราเมลโทสต์ไอศครีมนมฮอกไกโด',
      },
    ],
  },
  [REWARD_KEY.ID_21]: {
    _id: REWARD_KEY.ID_21,
    order: 21,
    title: 'ไก่ย่างยุคเก้า',
    dishes: [
      {
        title: 'ไก่ย่างสูตรต้นตำหรับ',
      },
    ],
  },
  [REWARD_KEY.ID_22]: {
    _id: REWARD_KEY.ID_22,
    order: 22,
    title: 'Chuu banthat thong',
    dishes: [
      {
        title: 'เครื่องดื่ม 1 แก้ว + Potato fries',
      },
    ],
  },
  [REWARD_KEY.ID_23]: {
    _id: REWARD_KEY.ID_23,
    order: 23,
    title: 'โซจูหมูทะ',
    dishes: [
      {
        title: 'ผัดมาม่าแซ่บ',
      },
    ],
  },
  [REWARD_KEY.ID_24]: {
    _id: REWARD_KEY.ID_24,
    order: 24,
    title: 'เจอกันสุกี้หมาล่า',
    dishes: [
      {
        title: 'น้ำซุป 2 ซุป + น้ำจิ้ม ',
      },
    ],
  },
  [REWARD_KEY.ID_25]: {
    _id: REWARD_KEY.ID_25,
    order: 25,
    title: 'Call Moo คอลหมู',
    dishes: [
      {
        title: 'ตำคอลหมูย่าง',
      },
    ],
  },
  [REWARD_KEY.ID_26]: {
    _id: REWARD_KEY.ID_26,
    order: 26,
    title: 'แอนก๋วยเตี๋ยวคั่วไก่',
    dishes: [
      {
        title: 'เส้นใหญ่คั่วรวมกุ้ง',
      },
    ],
  },
  [REWARD_KEY.ID_27]: {
    _id: REWARD_KEY.ID_27,
    order: 27,
    title: 'ฮั้วคิทเช่น',
    dishes: [
      {
        title: 'เซทข้าวหน้าไก่',
      },
    ],
  },
  [REWARD_KEY.ID_28]: {
    _id: REWARD_KEY.ID_28,
    order: 28,
    title: 'อ้วนปังปิ้ง',
    dishes: [
      {
        title: 'ขนมปังก้อนราดสังขยาใบเตยจัมโบ้',
      },
    ],
  },
  [REWARD_KEY.ID_29]: {
    _id: REWARD_KEY.ID_29,
    order: 29,
    title: 'เล้งเตี๋ยวหมูต้มยำ',
    dishes: [
      {
        title: 'กุ้งอบวุ้นเส้น + น้ำจิ้มซีฟู้ด',
      },
    ],
  },
}
